import React, {Component} from 'react';
import {contactToLink, contactTypeToIconName} from '../contactHelper';
import {createSelector} from 'reselect';
import FancyButton from '../widgets/FancyButton';

import './SocialList.css';

const getSortedContacts = createSelector(
	props => props.contacts,
	contacts =>
		contacts &&
		contacts
			.filter(contact => contact.detail && contact.detail.length)
			.sort((a, b) => a.type.localeCompare(b.type))
);

class SocialList extends Component {
	render() {
		const {name} = this.props;
		const contacts = getSortedContacts(this.props);

		if (!contacts || !contacts.length) {
			return (
				<div className="SocialList-none">
					<span>{name} has no contact information yet.</span>
				</div>
			);
		}

		return (
			<ol className="SocialList">
				{contacts.map(contact => (
					<li key={contact.type}>
						<a href={contactToLink(contact)} target="_blank" rel="noopener noreferrer">
							<span className={`icon ${contactTypeToIconName(contact.type)}`} />
							<span className="SocialList-handle">{contact.detail}</span>
						</a>
					</li>
				))}
			</ol>
		);
	}
}

export default SocialList;



// WEBPACK FOOTER //
// ./src/widgets/SocialList.js